// Served from public/, not imported: this module is loaded by Playwright's Node loader as well as by
// the browser, and a top-level image import cannot be resolved there. jsPDF's addImage takes a URL
// and fetches it, which is exactly what the bundler used to hand it.
const quoteHeaderSection = docData => {
  docData.doc.addImage('/images/sandbox-purple.png', 'PNG', 0, docData.yAxis, 158, 40)

  const image = docData.doc.addImage(
    '/images/soundbyte-red.png',
    'PNG',
    docData.doc.internal.pageSize.getWidth() - 181,
    docData.yAxis,
    181,
    40
  )

  docData.yAxis += 40 + docData.buffer

  return docData
}

export default quoteHeaderSection
